// extracted by mini-css-extract-plugin
module.exports = {"base":"LoadingPage_base__542hT","title":"LoadingPage_title__H4Zqp","loading-text":"LoadingPage_loading-text__Ll6TE","flashing":"LoadingPage_flashing__BsCb4"};